<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Nachricht an alle Kunden erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.messages.store'))">
                <form-fields :form="form" :message-type-options="messageTypeOptions" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'messageTypeOptions',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    message_type: null,
                    subject: null,
                    text: null,
                    send_message: false,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>